module.exports = __webpack_public_path__ + "static/media/trip-upload.761eb3d1.svg";